import { ISymbolsHandler } from '../../getSymbolsChecks.types';

export const handlerUnderline: ISymbolsHandler = (opts) => {
  const { text, index, symbolMatches } = opts;
  const underlineTag = text.substring(index, index + 2);

  if (underlineTag === '__') {
    symbolMatches['__'].push({
      start: index,
      end: index + 2,
    });
  }
};
